import { colors, text } from '@annote/core/styles';

export const suggestionStyles = `
  .suggestion-add {
    border-radius: 2px;
    position: relative;
    background-color: ${colors.bg.suggestion.primary};
    border-bottom: 2px solid ${colors.button.accept.primary};

    &:hover {
      background-color: ${colors.bg.suggestion.hover};
      border-bottom: 2px solid ${colors.button.accept.hover};
    }
  }

  .suggestion-delete {
    text-decoration: line-through;
    color: ${colors.button.reject.primary};
    position: relative;

    &:hover {
      background-color: ${colors.bg.suggestion.hover};
      border-bottom: 2px solid ${colors.button.reject.hover};
    }
  }

  .suggestion-hover-menu {
    display: none;
    position: absolute;
    z-index: 10;
    bottom: 100%;
    left: 0;
    margin-bottom: 0px;
    transition-delay: 0.1s;
    transition-property: display;
  }

  .suggestion-reason {
    background-color: ${colors.bg.primary};
    padding: 5px;
    border-radius: 4px;
    font-size: ${text.size.small};
    margin-bottom: 10px; // height of the reason above text
    box-shadow: ${colors.shadow.active};
    min-width: 150px;
    white-space: nowrap;
    box-shadow: ${colors.shadow.active};

  }

  /* Add a pseudo-element to bridge the gap between suggestion and hover-menu */
  .suggestion-add::before,
  .suggestion-delete::before {
    content: '';
    position: absolute;
    height: 10px;
    width: 100%;
    bottom: 100%;
    left: 0;
    z-index: 9;
  }

  /* Show hover-menu when hovering over suggestion marks */
  .suggestion-delete:hover .suggestion-hover-menu,
  .suggestion-add:hover .suggestion-hover-menu,
  .suggestion-hover-menu:hover {
    display: block;
  }

  .suggestion-buttons {
    position: absolute;
    display: flex;
    bottom: 0px;
    z-index: 11;
    margin-left: 6px;
  }

  .suggestion-accept,
  .suggestion-reject {
    padding: 4px;
    border: none;
    border-radius: 3px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 16px;
    height: 16px;

    svg {
      width: 12px;
      height: 12px;
      stroke-width: 1px;
    }
  }

  .suggestion-accept {
    background-color: ${colors.button.accept.primary};
    color: ${colors.text.button};

    &:hover {
      background-color: ${colors.button.accept.hover};
    }
  }

  .suggestion-reject {
    background-color: ${colors.button.reject.primary};
    color: ${colors.text.button};

    &:hover {
      background-color: ${colors.button.reject.hover};
    }
  }

  .suggestion-info {
    margin-bottom: 5px;
  }
`;
